import { memo } from 'preact/compat'
import type { ComponentChildren } from 'preact'
import type { AttributionItemDto } from '@/types/analytics'
import { MetricBarList, type BarListItem } from './MetricBarList'

interface Props {
  title: string
  icon?: ComponentChildren
  items: AttributionItemDto[] | undefined
  emptyMessage?: string
  maxItems?: number
  bare?: boolean
  className?: string
  loading?: boolean
  error?: string | null
}

/**
 * Renders a top-N attribution list (top referrers / top UTM campaigns) using the shared
 * {@link MetricBarList}. Each row is ranked by session count; credited conversions, when
 * present, are shown as a muted secondary figure (ORB-373).
 */
export const TopAttributionList = memo(({ title, icon, items, emptyMessage, maxItems, bare, className, loading, error }: Props) => {
  const rows: BarListItem[] = (items ?? []).map(item => ({
    label: item.Label,
    value: item.Sessions?.Current ?? 0,
    secondary: item.Conversions ? `${item.Conversions.Current.toLocaleString()} conv` : undefined,
  }))

  return (
    <MetricBarList
      title={title}
      icon={icon}
      items={rows}
      emptyMessage={emptyMessage}
      maxItems={maxItems}
      bare={bare}
      className={className}
      loading={loading}
      error={error}
    />
  )
})
